import { BroadcastChannel } from 'broadcast-channel';

import { WORKLIST_UPDATE } from 'config/constants';

export enum WorklistRefetchReason {
  Countdown = 'countdown',
  Discard = 'discard',
}

export type WorklistUpdateMessage = {
  smid: string;
  reason: WorklistRefetchReason;
};

export const worklistUpdateBc: BroadcastChannel<WorklistUpdateMessage> =
  new BroadcastChannel<WorklistUpdateMessage>(WORKLIST_UPDATE);
